import { Pipe, PipeTransform } from '@angular/core';
import { TranslationDirective } from '../app/shared-module/directives/translation.directive';
import { LOCALE_KEY } from '../services/user-service/user-token.service';

@Pipe({
  name: 'toDistance',
  pure: true,
  standalone: false,
})
export class ToDistancePipe implements PipeTransform {
  transform( valueInMeters: number | string | null | undefined ): string {
    if ( valueInMeters === null || valueInMeters === undefined || valueInMeters === '' ) {
      return '';
    }

    const meters = Number(valueInMeters);
    if ( isNaN(meters) ) {
      return '';
    }

    if ( meters >= 1000 ) {
      const km = this.applyDecimalSeparator((meters / 1000).toFixed(1));
      const unit = TranslationDirective.data?.ACTION_LEAD_BROKER_START_OVERLAY_DISTANCE_KM ?? 'km';
      return `${km} ${unit}`;
    }

    const unit = TranslationDirective.data?.ACTION_LEAD_BROKER_START_OVERLAY_DISTANCE_M ?? 'm';
    return `${Math.round(meters)} ${unit}`;
  }

  private applyDecimalSeparator( value: string ): string {
    const locale = sessionStorage.getItem(LOCALE_KEY) ?? '';

    return locale.toLowerCase().startsWith('en') ? value : value.replace('.', ',');
  }
}
